import React from 'react';
import { MainLayoutHeader, MainLayoutHeaderProps } from '@app/components';

export const RHHeader = ({ children }: Pick<MainLayoutHeaderProps, 'children'>) => {
  return (
    <MainLayoutHeader
      tabs={[
        { label: 'Pointages', screenName: 'TimesheetScreen', permissions: ['dashboard::timesheets.read'] },
      ]}
    >
      {children}
    </MainLayoutHeader>
  );
};

